// const url = "http://172.16.6.43:8080/getinfo/";
const url = "https://gpt-tripplanner.mobiloitte.io/getinfo/";


const ApiConfig = {
  login: `${url}/user/user-login`,
  tripplan: `${url}`,
};
export default ApiConfig;